import React from 'react';
import numberWithCommas from './number-with-commas.jsx';
import us_states from './us_states';

class PaymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        golf_club: 'srgc'
    };
  }

  componentDidMount() {
    let $ = jQuery;
    let that = this;
    $('.js-home-club').on('change click', function() {
        if ($(this).is(':checked')) {
            that.setState({
                golf_club: $(this).val()
            });
        }
    });
    $('.js-home-club[type="hidden"]').each(function() {
        that.setState({
            golf_club: $(this).val()
        });
    });
  }

  render() {
    const props = this.props;
    const plan_title = props.title;
    const plan_price = props.price;
    const final_price = props.final_price;
    const is_admin = props.is_admin;
    const renewal = props.renewal;
    const year = (new Date()).getFullYear();
    const terms_and_conditions = props.terms_and_conditions;
    const charging_account_terms_and_conditions = props.charging_account_terms_and_conditions;
    const golf_club = this.state.golf_club;

    return <div className="membership-app-section" id="ma-payment">
      <h2 className="section-title">
        Club Charging Account Application
      </h2>
      <h3 className="section-subtitle">
          <strong className="plan-name">{plan_title}</strong> - <span className="plan-price">${final_price} <small>(tax included)</small></span>
      </h3>
      <br />
      <div className="section-content">
          <div id="ma-payment-form" className="section-form">
              <div id="ma-payment-method">

                  <fieldset className="hidden-block" id="ma-payment-method-skip">
                      <div className="row">
                          <div className="col-md-12">
                              <div className="form-group form-group-with-inputs">
                                  <label className="radio-inline">
                                      <input type="radio" name="payment[partial_payment]" className="js-partial-payment" value="full" defaultChecked={true} /> Paid in Full By Check
                                  </label>
                                  <label className="radio-inline">
                                      <input type="radio" name="payment[partial_payment]" className="js-partial-payment" value="partial" /> Partial Payment
                                  </label>
                                  <label className="inputs hidden-inline">
                                      <input type="number" className="form-control" name="payment[partial_payment_amount]" id="payment_partial_payment" maxLength={16} />
                                  </label>
                              </div>
                          </div>
                          <div className="col-md-12">
                              <div className="form-group">
                                  <label>Form of Payment:</label>
                                  <div>
                                      <label className="radio-inline">
                                          <input type="radio" name="payment[payment_type]" value="Cash" defaultChecked={true} /> Cash
                                      </label>
                                      <label className="radio-inline">
                                          <input type="radio" name="payment[payment_type]" value="Check" /> Check
                                      </label>
                                      <label className="radio-inline">
                                          <input type="radio" name="payment[payment_type]" value="Credit Card" /> Credit Card
                                      </label>
                                      <label className="radio-inline">
                                          <input type="radio" name="payment[payment_type]" value="Gift Card" /> Gift Card
                                      </label>
                                      <label className="radio-inline">
                                          <input type="radio" name="payment[payment_type]" value="Other" /> Other
                                      </label>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </fieldset>
                  {/* <fieldset className="hidden-block" id="ma-payment-method-cc">
                      <div className="row">
                          <div className="col-md-5">
                              <div className="form-group">
                                  <label htmlFor="payment_cc_number">Credit Card Number:</label>
                                  <div className="form-control-wrapper">
                                      <input type="text" className="form-control" name="payment[cc_number]" pattern="[0-9]*" id="payment_cc_number" maxLength={16} data-required required />
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor="payment_cc_exp_month">Exp. Date:</label>
                                  <div className="form-control-wrapper">
                                      <select className="form-control" name="payment[cc_exp][month]" id="payment_cc_exp_month" placeholder="Month" data-required required>
                                          <option value="">Month</option>
                                          {Array(12).fill().map((_, i) => {
                                            return <option key={i} value={i+1}>{i+1}</option>
                                          })}
                                      </select>
                                  </div>
                                  <label className="margin-before">/</label>
                                  <div className="form-control-wrapper">
                                      <select className="form-control" name="payment[cc_exp][year]" id="payment_cc_exp_year" placeholder="Year" data-required required>
                                          <option value="">Year</option>
                                          {Array(10).fill().map((_, i) => {
                                            return <option key={i} value={i+year}>{i+year}</option>
                                          })}
                                      </select>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-2">
                              <div className="form-group">
                                  <label htmlFor="payment_cc_code">Sec. Code:</label>
                                  <div className="form-control-wrapper">
                                      <input type="text" className="form-control" name="payment[cc_code]" pattern="[0-9]*" id="payment_cc_code" maxLength={4} minLength={3} data-required required />
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="form-group">
                          <label className="checkbox-inline">
                              <input type="checkbox" name="payment[uses_different_info]" className="js-payment-different-info" id="payment_different_info" value="1" />
                              Cardholder name and billing is different than listed on the {renewal ? 'membership information' : 'application'}
                          </label>
                      </div>
                      <fieldset className="hidden-block" id="ma-payment-different-info">
                          <div className="row">
                              <div className="col-md-5">
                                  <div className="form-group">
                                      <label htmlFor="payment_billing_info_first_name">First Name:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[billing_info][first_name]" id="payment_billing_info_first_name" data-required />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-2">
                                  <div className="form-group">
                                      <label htmlFor="payment_billing_info_middle_name">Middle Initial:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[billing_info][middle_name]" id="payment_billing_info_middle_name" />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-5">
                                  <div className="form-group">
                                      <label htmlFor="payment_billing_info_last_name">Last Name:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[billing_info][last_name]" id="payment_billing_info_last_name" data-required />
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className="form-group">
                              <label htmlFor="payment_billing_info_address">Billing Address:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[billing_info][address]" id="payment_billing_info_address" data-required />
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-6">
                                  <div className="form-group">
                                      <label htmlFor="payment_billing_info_city">City:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[billing_info][city]" id="payment_billing_info_city" data-required />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-group">
                                      <label htmlFor="payment_billing_info_state">State:</label>
                                      <div className="form-control-wrapper">
                                        <select className="form-control" name="payment[billing_info][state]" id="payment_billing_info_state" data-required>
                                            <option key="0" value=""></option>
                                            {Object.keys(us_states).map(k => {
                                                return <option key={k} value={k}>{us_states[k]}</option>
                                            })}
                                        </select>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-group">
                                      <label htmlFor="payment_billing_info_zipcode">Zip Code:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[billing_info][zipcode]" pattern="[0-9]*" id="payment_billing_info_zipcode" data-required />
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </fieldset>
                  </fieldset> */}
                  <fieldset className="hidden-block" id="ma-payment-charging-account">
                      <fieldset id="ma-payment-charging-account-info">
                          <div className="row">
                              <div className="col-xs-12">
                                  <div className="margin-bottom-15">Input credit card information to be kept on file per the terms of the Charge Account Application</div>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-5">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_cc_number">Credit Card Number:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[charging_account][cc_number]" pattern="[0-9]*" id="payment_charging_account_cc_number" maxLength={16} data-required />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_cc_exp_month">Exp. Date:</label>
                                      <div className="form-control-wrapper">
                                          <select className="form-control" name="payment[charging_account][cc_exp][month]" id="payment_charging_account_cc_exp_month" placeholder="Month" data-required>
                                              <option value="">Month</option>
                                              {Array(12).fill().map((_, i) => {
                                                return <option key={i} value={i+1}>{i+1}</option>
                                              })}
                                          </select>
                                      </div>
                                      <label className="text-center" style={{ minWidth: 20, marginRight: 0 }}>/</label>
                                      <div className="form-control-wrapper">
                                          <select className="form-control" name="payment[charging_account][cc_exp][year]" id="payment_charging_account_cc_exp_year" placeholder="Year" data-required>
                                              <option value="">Year</option>
                                              {Array(10).fill().map((_, i) => {
                                                return <option key={i} value={i+year}>{i+year}</option>
                                              })}
                                          </select>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div className="row">
                              <div className="col-md-5">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_first_name">First Name:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[charging_account][first_name]" id="payment_charging_account_first_name" data-required />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-2">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_middle_name">Middle Initial:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[charging_account][middle_name]" id="payment_charging_account_middle_name" />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-5">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_last_name">Last Name:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[charging_account][last_name]" id="payment_charging_account_last_name" data-required />
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className="form-group">
                              <label htmlFor="payment_charging_account_address">Billing Address:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[charging_account][address]" id="payment_charging_account_address" data-required />
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-6">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_city">City:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[charging_account][city]" id="payment_charging_account_city" data-required />
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_state">State:</label>
                                      <div className="form-control-wrapper">
                                        <select className="form-control" name="payment[charging_account][state]" id="payment_charging_account_state" data-required>
                                            <option key="0" value=""></option>
                                            {Object.keys(us_states).map(k => {
                                                return <option key={k} value={k}>{us_states[k]}</option>
                                            })}
                                        </select>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-3">
                                  <div className="form-group">
                                      <label htmlFor="payment_charging_account_zipcode">Zip Code:</label>
                                      <div className="form-control-wrapper">
                                          <input type="text" className="form-control" name="payment[charging_account][zipcode]" pattern="[0-9]*" id="payment_charging_account_zipcode" data-required />
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </fieldset>
                  </fieldset>
              </div>

              <div id="ma-same-credit-card-for-monthly-payments">
                <hr />
                <div className="form-group form-group-wrap">
                  <label>Do you want to use the same credit card information above for your 8 Monthly Payments</label>
                  <div>
                    <label className="radio-inline">
                      <input type="radio" name="member[same_card_for_monthly_payments]" className="js-same-card-for-monthly-payments" id="same_card_for_monthly_payments_yes" data-required value="1" required={props.require_same_credit_card_checkbox} /> Yes
                    </label>
                    <label className="radio-inline">
                      <input type="radio" name="member[same_card_for_monthly_payments]" className="js-same-card-for-monthly-payments" id="same_card_for_monthly_payments_no" data-required value="" required={props.require_same_credit_card_checkbox} /> No
                    </label>
                  </div>
                </div>

                <fieldset id="ma-payment-monthly-info" className="hidden">
                  <div className="row">
                      <div className="col-xs-12">
                          <div className="margin-bottom-15">Input credit card information to be used for Monthly Payments.</div>
                      </div>
                  </div>
                  <div className="row">
                      <div className="col-md-5">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_cc_number">Credit Card Number:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[monthly_payments][cc_number]" pattern="[0-9]*" id="payment_monthly_payments_cc_number" maxLength={16} data-required />
                              </div>
                          </div>
                      </div>
                      <div className="col-md-3">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_cc_exp_month">Exp. Date:</label>
                              <div className="form-control-wrapper">
                                  <select className="form-control" name="payment[monthly_payments][cc_exp][month]" id="payment_monthly_payments_cc_exp_month" placeholder="Month" data-required>
                                      <option value="">Month</option>
                                      {Array(12).fill().map((_, i) => {
                                        return <option key={i} value={i+1}>{i+1}</option>
                                      })}
                                  </select>
                              </div>
                              <label className="text-center" style={{ minWidth: 20, marginRight: 0 }}>/</label>
                              <div className="form-control-wrapper">
                                  <select className="form-control" name="payment[monthly_payments][cc_exp][year]" id="payment_monthly_payments_cc_exp_year" placeholder="Year" data-required>
                                      <option value="">Year</option>
                                      {Array(10).fill().map((_, i) => {
                                        return <option key={i} value={i+year}>{i+year}</option>
                                      })}
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div className="row">
                      <div className="col-md-5">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_first_name">First Name:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[monthly_payments][first_name]" id="payment_monthly_payments_first_name" data-required />
                              </div>
                          </div>
                      </div>
                      <div className="col-md-2">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_middle_name">Middle Initial:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[monthly_payments][middle_name]" id="payment_monthly_payments_middle_name" />
                              </div>
                          </div>
                      </div>
                      <div className="col-md-5">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_last_name">Last Name:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[monthly_payments][last_name]" id="payment_monthly_payments_last_name" data-required />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="form-group">
                      <label htmlFor="payment_monthly_payments_address">Billing Address:</label>
                      <div className="form-control-wrapper">
                          <input type="text" className="form-control" name="payment[monthly_payments][address]" id="payment_monthly_payments_address" data-required />
                      </div>
                  </div>
                  <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_city">City:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[monthly_payments][city]" id="payment_monthly_payments_city" data-required />
                              </div>
                          </div>
                      </div>
                      <div className="col-md-3">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_state">State:</label>
                              <div className="form-control-wrapper">
                                <select className="form-control" name="payment[monthly_payments][state]" id="payment_monthly_payments_state" data-required>
                                    <option key="0" value=""></option>
                                    {Object.keys(us_states).map(k => {
                                        return <option key={k} value={k}>{us_states[k]}</option>
                                    })}
                                </select>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-3">
                          <div className="form-group">
                              <label htmlFor="payment_monthly_payments_zipcode">Zip Code:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="payment[monthly_payments][zipcode]" pattern="[0-9]*" maxLength={5} id="payment_monthly_payments_zipcode" data-required />
                              </div>
                          </div>
                      </div>
                  </div>
                </fieldset>
              </div>
              

              <div id="ma-terms-acceptance">
                  <h2 className="section-title">
                      Terms &amp; Conditions Acceptance
                  </h2>
                  <br />
                  <div className="form-group hidden-block" id="ma-terms-young-pro">
                      <label className="checkbox-inline checkbox-inline-top">
                          <input type="checkbox" name="payment[terms_young_pro]" id="terms_young_pro" value="1" data-required="" />
                          <span>Proof of age is required before your membership will be processed.<br />Simply take a photo of your driver's license with your phone and send to <a href="mailto:membership@ottingergolf.com">membership@ottingergolf.com</a>.</span>
                      </label>
                  </div>
                  <div className="form-group" id="ma-terms">
                      <label className="checkbox-inline">
                          <input type="checkbox" name="terms" id="terms" value="1" data-required required />
                          I read and agree to&nbsp;<a href={terms_and_conditions} target="_blank">Terms &amp; Conditions</a>
                      </label>
                  </div>
                  <div className="form-group hidden-block" id="ma-terms-charging-account">
                      <label className="checkbox-inline pt-0">
                          <input type="checkbox" name="terms_charging_account" id="terms_chargin_account" value="1" data-required />
                          I read and agree to&nbsp;<a href={charging_account_terms_and_conditions} target="_blank">Charging Account Terms &amp; Conditions</a>
                      </label>
                  </div>
                  <hr />
                  <fieldset>
                      <div className="row">
                          <div className="col-md-12">
                              <div className="form-group no-flex pull-left">
                                  <label>Signature:</label>
                                  <div>
                                      <input type="hidden" id="signature-input" name="member[signature]" />
                                      <canvas id="signature" width="570" height="200" className="form-signature"></canvas>
                                      <br />
                                      <button type="button" className="button button-default button-small js-clear-signature">Clear Signature</button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </fieldset>
                  <h2 className="section-title">
                      Payment
                  </h2>
                  <br />
                  <div className="form-group">
                      <p>Membership application will not be processed until payment in full by check or installment deposit has been received.</p>
                  </div>
                  <div className="form-group">
                    <p>Please send check for ${numberWithCommas(final_price)} to {golf_club === 'srgc' ? 'Scotland Run Golf Club' : 'Ballamor Golf Club'} and include your Membership type and name of applicant if different from the name on the check.</p>
                  </div>
                  <div className="form-group">
                    <p>For installment payments inquire with the Golf Shop at 609-601-6220</p>
                  </div>
                  <div className="form-group">
                    {golf_club === 'srgc'
                        ? <p>Scotland Run Golf Club<br />2626 Fries Mill Rd<br />Williamstown, NJ 08094</p>
                        : <p>Ballamor Golf Club<br />6071 English Creek Ave<br />Egg Harbor Twp, NJ 08234</p>}
                  </div>
                  <hr />
              </div>
              <div className="form-actions text-right">
                  <button type="button" className="button button-default button-back js-back">Back</button>
                  <button type="button" className="button button-primary button-continue" onClick={props.onSubmit}>Complete Application</button>
              </div>
          </div>
      </div>
      <input type="hidden" name="post_type" value="product" />
      <input type="hidden" name="postname" value={props.slug} />
    </div>
  }
}

export default PaymentForm;